import BaseAPI from '../baseApi';
import { configuration } from '../../configuration';
import { Checkout, CreateCheckout } from '../interfaces';

export class CheckoutApi extends BaseAPI {
  prefix = ''; // TODO: change when using RSA API

  get host(): string {
    return configuration.checkoutFunctionUrl;
  }

  async createCheckoutUrl(params: CreateCheckout): Promise<Checkout> {
    const { order } = await this.post<{ order: Checkout }>('', params);
    return order;
  }

  async headers(): Promise<Record<string, string>> {
    return await this.minibarHeaders();
  }

  async body(params: CreateCheckout): Promise<CreateCheckout & { env: string }> {
    return { ...params, env: configuration.env };
  }
}
